export { AeraImage, DataTableImage } from '@aera/data-table'
export type { AeraImageProps, DataTableImageProps } from '@aera/data-table'
